
export const FETCH_IP_ADDRESS_LISTING_FAILURE = 'FETCH_IP_ADDRESS_LISTING_FAILURE';
export const FETCH_IP_ADDRESS_LISTING_SUCCESS = 'FETCH_IP_ADDRESS_LISTING_SUCCESS';

export const RESET = 'RESET';
